// assets
import { IconCoin } from '@tabler/icons';
import CoinAoneDark from '../assets/images/CoinAoneDark';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CampaignIcon from '@mui/icons-material/Campaign';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ArticleIcon from '@mui/icons-material/Article';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PaymentsIcon from '@mui/icons-material/Payments';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import BuildIcon from '@mui/icons-material/Build';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import SavingsIcon from '@mui/icons-material/Savings';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CalculateIcon from '@mui/icons-material/Calculate';
import AssessmentIcon from '@mui/icons-material/Assessment';
// constant
const icons = {
    AccountBalanceIcon,
    PieChartOutlineIcon,
    SavingsIcon,
    ReceiptLongIcon,
    ReportProblemIcon,
    CalculateIcon,
    AssessmentIcon,
    IconCoin,
    CoinAoneDark,
    SummarizeIcon,
    CardGiftcardIcon,
    CampaignIcon,
    CreditCardIcon,
    ArticleIcon,
    FolderOpenIcon,
    PaymentsIcon,
    PriceCheckIcon,
    PlaylistAddCheckCircleIcon,
    FileDownloadIcon,
    WhatsAppIcon,
    BuildIcon
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

function children() {
    const children = [];
    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('31')) {
            children.push({
                id: 'exchangerate',
                title: 'Exchange Rate',
                type: 'item',
                url: '/financial/exchangerate',
                target: false,
                icon: icons.IconCoin
            });
        }

        if (Roles.includes('34')) {
            children.push({
                id: 'aonewallet',
                title: 'Aone Wallet Controller',
                type: 'item',
                url: '/financial/aonewallet',
                target: false,
                icon: icons.CoinAoneDark
            });
            children.push({
                id: 'aonewalletHistory',
                title: 'AoneWallet History',
                type: 'item',
                url: '/financial/aonewallet/history',
                target: false,
                icon: icons.SummarizeIcon
            });
            children.push({
                id: 'creditnoterequirement',
                title: 'Credit Note',
                caption: 'Top up',
                type: 'item',
                url: '/financial/aonewallet/credit',
                target: false,
                icon: icons.CardGiftcardIcon
            });
            children.push({
                id: 'creditInvoice',
                title: 'Credit Invoice',
                type: 'collapse',
                target: false,
                icon: icons.CreditCardIcon,
                children: [
                    {
                        id: 'creditInvoice-Controller',
                        title: 'CreditInvoice Controller',
                        caption: 'Pay of debt',
                        type: 'item',
                        url: '/financial/aonewallet/creditinvoice',
                        icon: icons.PaymentsIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'creditInvoice-verify',
                        title: 'Invoice Requirement',
                        caption: 'Verify & Check',
                        type: 'item',
                        url: '/financial/aonewallet/Verify/creditinvoice',
                        icon: icons.PriceCheckIcon,
                        breadcrumbs: false
                    },
                    // {
                    //     id: 'cashback-verify',
                    //     title: 'Verify Cashback',
                    //     caption: 'Cashback (no credit)',
                    //     type: 'item',
                    //     url: '/financial/aonewallet/Verify/cashback',
                    //     icon: icons.PriceCheckIcon,
                    //     breadcrumbs: false
                    // },
                    // {
                    //     id: 'qrpayment-verify',
                    //     title: 'QR Payment Verify',
                    //     caption: 'Finance verify LaoQR',
                    //     type: 'item',
                    //     url: '/financial/aonewallet/verify/qrpayment',
                    //     icon: icons.PriceCheckIcon,
                    //     breadcrumbs: false
                    // }
                ]
            });
            children.push({
                id: 'announcementrequest',
                title: 'Announcement Requirement',
                type: 'item',
                url: '/financial/aonewallet/announcement',
                target: false,
                icon: icons.CampaignIcon
            });
            children.push({
                id: 'claimcheck',
                title: 'Claim Check',
                type: 'item',
                url: '/financial/claimcheck',
                target: false,
                icon: icons.PlaylistAddCheckCircleIcon
            });
            children.push({
                id: 'finance-verify',
                title: 'Verify Center',
                type: 'collapse',
                icon: icons.PriceCheckIcon,
                children: [
                    {
                        id: 'cashback-verify',
                        title: 'Cashback verify',
                        caption: 'Cashback (no credit)',
                        type: 'item',
                        url: '/financial/aonewallet/Verify/cashback',
                        target: false,
                        icon: icons.PriceCheckIcon
                    },
                    {
                        id: 'repairstock-verify',
                        title: 'Verify Repair Stock',
                        caption: 'ເຄື່ອງສ້ອມແປງ + Wallet ທົດແທນ',
                        type: 'item',
                        url: '/financial/repairstock/verify',
                        target: false,
                        icon: icons.BuildIcon
                    },
                    {
                        id: 'qrpayment-verify',
                        title: 'Finance verify LaoQR',
                        type: 'item',
                        url: '/financial/aonewallet/verify/qrpayment',
                        target: false,
                        icon: icons.PriceCheckIcon
                    },
                    {
                        id: 'stockimportlist',
                        title: 'Verification Stock Import',
                        type: 'item',
                        url: '/financial/stockimportlist',
                        target: false,
                        icon: icons.FileDownloadIcon
                    }
                ]
            });
            children.push({
                id: 'whatsapp',
                title: 'WhatsApp',
                type: 'item',
                url: '/financial/whatsapp',
                target: false,
                icon: icons.WhatsAppIcon
            });
            children.push({
                id: 'reports-finance',
                title: 'Finance Report',
                type: 'collapse',
                icon: icons.FolderOpenIcon,
                children: [
                    {
                        id: 'reports-aging-creditinvoice',
                        title: 'CreditInvoice Aging Report',
                        type: 'item',
                        url: '/financial/report/agingcreditinvoice',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-usage-creditnote',
                        title: 'CreditNote Usage Report',
                        type: 'item',
                        url: '/financial/report/creditnoteusage',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-usage-credithistory',
                        title: 'CreditNote History Report',
                        type: 'item',
                        url: '/financial/report/credithistory',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-usage-creditinvoicehistory',
                        title: 'Creditinvoice History Report',
                        type: 'item',
                        url: '/financial/report/creditinvoicehistory',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-finance-saleandstockcompare',
                        title: 'SaleAndStock Compare Report',
                        type: 'item',
                        url: '/financial/report/saleandstockcompare',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-finance-saleandstockmovement',
                        title: 'SaleAndStock Movement Report',
                        type: 'item',
                        url: '/financial/report/saleandstockmovement',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-finance-cashback',
                        title: 'Cashback Report',
                        type: 'item',
                        url: '/reports/cashback',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    }
                ]
            });
        }

        // ── Loan System ───────────────────────────────────────────────────────
        // Origination (65) and approval/servicing (66) are separate roles because
        // roleCheck resolves one role per (baseUrl, method): /api/loan is 65 and
        // /api/loanapproval is 66, so the two duties cannot share a router.
        //
        // Origination itself lives in the Menu group (menus.js) so every salesperson can
        // take an application; what stays here is Finance's own work — assessing a limit,
        // and the agreements the drawdowns produced.
        const loanChildren = [];
        if (Roles.includes('66')) {
            loanChildren.push({
                id: 'loan-approve',
                // Finance checks the paperwork and passes it on. Setting the limit is the
                // approval desk's call, at /approval/loan — the title said "approve" while
                // the button to do it was somewhere else entirely.
                title: 'ກວດສອບໃບສະໝັກ',
                caption: 'Review and verify',
                type: 'item',
                url: '/finance/loan/approve',
                icon: icons.PriceCheckIcon,
                breadcrumbs: false
            });
            
            loanChildren.push({
                id: 'loan-followup',
                title: 'ຕິດຕາມສັນຍາ',
                caption: 'Activity · WhatsApp · Knox · payments',
                type: 'item',
                url: '/finance/loan/followup',
                icon: icons.PlaylistAddCheckCircleIcon,
                breadcrumbs: false
            });
            // Beside the follow-up desk, because it is the same job: money that arrived where
            // the system could not see it, and a second person agreeing it did.
            loanChildren.push({
                id: 'loan-payment-requests',
                title: 'ຄຳຂໍບັນທຶກການຊຳລະ',
                caption: 'Approve off-QR payments',
                type: 'item',
                url: '/finance/loan/payment-requests',
                icon: icons.PlaylistAddCheckCircleIcon,
                breadcrumbs: false
            });
            // Reports get their own sub-group rather than four more entries beside the
            // working screens: approve/contracts/follow-up are things Finance DOES, these
            // are things Finance READS, and mixing them makes the daily work harder to find.
            loanChildren.push({
                id: 'loan-reports',
                title: 'ລາຍງານ',
                caption: 'Reports',
                type: 'collapse',
                icon: icons.AssessmentIcon,
                children: [
                    {
                        id: 'loan-report-portfolio',
                        title: 'ພາບລວມ + PAR',
                        caption: 'Portfolio at risk',
                        type: 'item',
                        url: '/finance/loan/report/portfolio',
                        icon: icons.PieChartOutlineIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'loan-report-collections',
                        title: 'ເກັບເງິນ',
                        caption: 'Collections · daily cash',
                        type: 'item',
                        url: '/finance/loan/report/collections',
                        icon: icons.SavingsIcon,
                        breadcrumbs: false
                    },
                    {
                        // Sits next to Collections deliberately: same source data, different
                        // question. Collections is the accounting split, this is the searchable
                        // ledger somebody opens when a customer says "I already paid".
                        id: 'loan-report-payments',
                        title: 'ປະຫວັດການຊຳລະ',
                        caption: 'Payment history · search by name',
                        type: 'item',
                        url: '/finance/loan/report/payments',
                        icon: icons.ReceiptLongIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'loan-report-arrears',
                        title: 'ໜີ້ຄ້າງ',
                        caption: 'Arrears worklist',
                        type: 'item',
                        url: '/finance/loan/report/arrears',
                        icon: icons.ReportProblemIcon,
                        breadcrumbs: false
                    },
                    {
                       id: 'loan-contracts',
                       title: 'ສັນຍາກູ້ຢືມ',
                        caption: 'Used applications · schedule',
                        type: 'item',
                        url: '/finance/loan/contracts',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                     {
                        id: 'loan-list-finance',
                        title: 'ໃບສະໝັກທັງໝົດ',
                        type: 'item',
                        url: '/finance/loan/applications',
                        icon: icons.FolderOpenIcon,
                        breadcrumbs: false
                    },
                    // ບັນຊີສິ້ນເດືອນ (accrual + provision) is switched off for now — the loan
                    // book is too young for a month to have been closed, so the page opens
                    // empty. To bring it back, restore this entry AND the matching route in
                    // routes/MainRoutes.js; the screen and its endpoints are untouched.
                    // {
                    //     id: 'loan-report-accounting',
                    //     title: 'ບັນຊີສິ້ນເດືອນ',
                    //     caption: 'Accrual · provision',
                    //     type: 'item',
                    //     url: '/finance/loan/report/accounting',
                    //     icon: icons.CalculateIcon,
                    //     breadcrumbs: false
                    // }
                ]
            });
            // loanChildren.push({
            //     id: 'loan-contracts',
            //     title: 'ສັນຍາກູ້ຢືມ',
            //     caption: 'Used applications · schedule',
            //     type: 'item',
            //     url: '/finance/loan/contracts',
            //     icon: icons.ArticleIcon,
            //     breadcrumbs: false
            // });
        }
        // if (Roles.includes('65')) {
        // if (Roles.includes('34')) {
        //     loanChildren.push({
        //         id: 'loan-list-finance',
        //         title: 'ໃບສະໝັກທັງໝົດ',
        //         type: 'item',
        //         url: '/finance/loan/applications',
        //         icon: icons.FolderOpenIcon,
        //         breadcrumbs: false
        //     });
        // }
        if (loanChildren.length) {
            children.push({
                id: 'loan-system',
                title: 'Loan System',
                type: 'collapse',
                icon: icons.AccountBalanceIcon,
                children: loanChildren
            });
        }
    }
    return children;
}
const finance = {
    id: 'financial',
    title: 'Financial',
    type: 'group',
    children: children()
};

export default finance;
